import React from 'react'
import { Container, Row, Col } from "react-bootstrap";
import { Button, Tooltip } from "antd";
import { useNavigate } from 'react-router-dom';
import { useData } from "../../../context/DataContext";
import { useBookingRestrictionStore } from '../../../context/BookingRestrictionContext';

const Banner = () => {
  const navigate = useNavigate();
  const { disabled, tooltipMessage} = useData();
  // const { showRestrictionModal } = useBookingRestrictionStore();
  const CustomButton = tooltipMessage ? (
      <Tooltip title={tooltipMessage}>
          <span>
            <Button
                className="fs-16 fw-700 booking-btn text-black"
                size="large"
                style={{borderColor: '#272727'}}
                disabled={disabled}
                onClick={() => {
                  navigate('/booking');
                  // showRestrictionModal(true);
                }}
              >
                Book Now
            </Button>
          </span>
      </Tooltip>
  ) : (
    <Button
        className="fs-16 fw-700 booking-btn"
        size="large"
        style={{borderColor: '#272727'}}
        onClick={() => {
          navigate('/booking');
          // showRestrictionModal(true);
        }}
      >
        Book Now
    </Button>
  );

  return (    
    <div>
      <video
        className="banner-wrapper"
        autoPlay
        loop
        muted
        playsInline
        disablePictureInPicture
        controls={false}
        controlsList="nodownload noplaybackrate nofullscreen"
      >
        <source 
          src={require('../../../assets/videos/headervideo/header-video.mp4')} 
          type="video/mp4"
        />
      </video>
      
      <div className="gradient-overlay">
        <Container className="py-5" >
          <Row className="d-flex align-items-center justify-content-center">
            <Col xxl={6} xl={6} lg={8} md={10} sm={12} xs={12} className="text-center">
              <p className="fs-28 fw-400 sub-header text-black mb-1">
                Dive into the Fun
              </p>
              <p className='fw-400 header'>
                Activities
              </p>
              <p className='sub-heading-text fw-400 text-black'>
                Get ready for an adrenaline-packed adventure with our exciting lineup of activities!
              </p>
            </Col>
          </Row>

          <Row className='d-flex align-items-center justify-content-center'>
            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className='text-center'>
              {CustomButton}
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  )
}

export default Banner
